module.exports = __webpack_public_path__ + "static/media/logo195.b4a483c0.png";